import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './validDeleteGroupDialog.module.scss'
import { useMutation } from '@apollo/client'
import { DELETE_GROUP } from '@/modules/API/daycare/groupHandler'
import { Close, Delete } from '@mui/icons-material'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ValidDeleteGroupProps {
    open: boolean
    handleClose: () => void
    groupId: number
    daycareId: number
    removeOneGroup: (groupId: number) => void
}

const ValidDeleteGroupDialog: FunctionComponent<ValidDeleteGroupProps> = ({
    open,
    handleClose,
    groupId,
    daycareId,
    removeOneGroup
}: ValidDeleteGroupProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneGroup] = useMutation(DELETE_GROUP, {
        variables: {
            group_id: groupId,
            daycare_id: daycareId,
            new_group_id: 0
        },
        onCompleted: () => {
            showNotificationSuccess(t('groupPriorityDeleted'))

            removeOneGroup(groupId)

            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedGroupPriority'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeleteGroupPriority')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeleteGroupPriorityMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteOneGroup}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ValidDeleteGroupDialog
